/* kata-quickadd.js
 * Single-variant: instant POST /cart/add.js → open Shrine PRO cart drawer
 * Multi-variant: redirect to product URL
 * Attaches to .quick-add-btn[data-product-url][data-variant-id][data-variant-count]
 */

(function () {
  'use strict';

  function openCartDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    if (typeof drawer.open === 'function') {
      drawer.open();
      return;
    }

    drawer.classList.add('active', 'is-empty--false');
    drawer.removeAttribute('hidden');

    const overlay = document.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.classList.add('active');

    document.body.classList.add('overflow-hidden');
  }

  function refreshCartDrawer() {
    const sectionsToRender = [
      { id: 'cart-drawer', selector: 'cart-drawer' },
      { id: 'cart-icon-bubble', selector: '#cart-icon-bubble' }
    ];

    const sectionIds = sectionsToRender.map(s => s.id).join(',');

    fetch(`/cart?sections=${sectionIds}`)
      .then(r => r.json())
      .then(data => {
        sectionsToRender.forEach(({ id, selector }) => {
          const el = document.querySelector(selector);
          if (!el || !data[id]) return;
          const parsed = new DOMParser().parseFromString(data[id], 'text/html');
          const updated = parsed.querySelector(selector);
          if (updated) el.innerHTML = updated.innerHTML;
        });
        openCartDrawer();
      })
      .catch(() => {
        openCartDrawer();
      });
  }

  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] })
    }).then(r => {
      if (!r.ok) return r.json().then(err => Promise.reject(err));
      return r.json();
    });
  }

  function handleQuickAdd(btn) {
    if (btn.dataset.kataQuickAdd) return;
    btn.dataset.kataQuickAdd = '1';

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const variantCount = parseInt(btn.dataset.variantCount || '1', 10);
      const productUrl = btn.dataset.productUrl;
      const variantId = btn.dataset.variantId;

      if (variantCount > 1) {
        if (productUrl) window.location.href = productUrl;
        return;
      }

      if (!variantId) return;

      btn.disabled = true;
      const originalText = btn.textContent;
      btn.textContent = '...';

      addToCart(variantId, 1)
        .then(() => {
          refreshCartDrawer();
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        })
        .catch(err => {
          console.error('Kata quick-add error:', err);
        })
        .finally(() => {
          btn.disabled = false;
          btn.textContent = originalText;
        });
    });
  }

  function attachAll() {
    document.querySelectorAll('.quick-add-btn').forEach(handleQuickAdd);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachAll);
  } else {
    attachAll();
  }

  document.addEventListener('shopify:section:load', attachAll);
  document.addEventListener('page:load', attachAll);
})();
